<LayoutMain class="personals-list relative">
  <!-- Ensure the top breadcrumb renders -->
  <PersonalsTopBar :showCreateCTA="true" />

  <!-- Hero Action Bar -->
  <PersonalsActionBar
    @create="handleCreateFromActionBar"
    @myAds="handleMyAdsFromActionBar"
    class="relative z-10"
  />

  <!-- Enhanced Layout with Magical Elements -->

  <!-- Error Display -->
  <ErrorDisplay v-if="error" :error="error" @retry="handleRefresh" class="mb-6" />

  <!-- Enhanced Loading State with Skeletons -->
  <div v-if="isLoading && !filteredAds.length" class="relative z-10">
    <!-- Action Bar Skeleton -->
    <LoadingSkeleton variant="actionBar" class="mb-6" />

    <!-- Cards Skeletons -->
    <div class="ads-grid">
      <LoadingSkeleton
        v-for="i in 6"
        :key="i"
        variant="personalCard"
        :style="{ 'animation-delay': `${i * 0.1}s` }"
      />
    </div>
  </div>

  <!-- Enhanced Empty State -->
  <div v-else-if="!hasAds && !isLoading" class="empty-state relative z-10">
    <div
      class="mx-auto max-w-md rounded-xl border border-outline-variant bg-surface-container-lowest p-8 shadow-md"
    >
      <div class="text-center">
        <div
          class="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-secondary-fixed"
        >
          <Plus class="h-9 w-9 text-secondary" />
        </div>

        <Text variant="body" class="mb-2 font-headline text-headline-md text-primary">
          {{ t('personals.noAds') }}
        </Text>

        <Text variant="body" class="mb-8 font-body text-body-md leading-relaxed text-on-surface-variant">
          {{ t('personals.noAdsDescription') }}
        </Text>

        <button
          @click="navigateToCreate"
          class="inline-flex items-center rounded-lg bg-primary px-8 py-4 font-label text-label-md text-on-primary shadow-md transition hover:bg-primary-container"
        >
          <Plus :size="16" class="mr-2" />
          {{ t('personals.createFirstAd') }}
        </button>
      </div>
    </div>
  </div>

  <!-- Enhanced Ads Grid -->
  <div v-else-if="hasAds" class="ads-grid relative z-10">
    <PersonalAdCard
      v-for="ad in filteredAds"
      :key="ad.id"
      :ad="ad"
      @click="handleAdClick"
      @reply="handleReplyClick"
      class="transform transition-all duration-300 hover:z-20"
    />
  </div>

  <!-- Enhanced Load More -->
  <div v-if="pagination.hasMore && hasAds" class="load-more-container relative z-10">
    <button
      @click="handleLoadMore"
      :disabled="isLoadingMore"
      class="inline-flex items-center rounded-lg border border-outline-variant bg-surface-container-lowest px-8 py-4 font-label text-label-md text-primary shadow-sm transition hover:bg-surface-container-low disabled:opacity-60"
    >
      <LoadingSpinner v-if="isLoadingMore" size="sm" class="mr-2" />
      {{ isLoadingMore ? t('personals.loadingStates.loading') : t('common.actions.loadMore') }}
    </button>
  </div>

  <!-- Enhanced Results Count -->
  <div v-if="hasAds" class="text-center py-6 relative z-10">
    <Text
      variant="caption"
      class="rounded-full border border-outline-variant bg-surface-container-low px-4 py-2 text-on-surface-variant"
    >
      {{ t('personals.showingResults', { count: filteredAds.length }) }}
      <span v-if="pagination.hasMore"> {{ t('personals.moreAvailable') }}</span>
    </Text>
  </div>
</LayoutMain>
